module.exports = __webpack_public_path__ + "media/images/emblems/Satigny-coat_of_arms-d5e2be368fa8c986dcc7f29490e72476.svg";